/* MAXIS Quiz — logique pure (browser + Node). Aucun DOM, aucun effet de bord. */
(function (global) {
  'use strict';

  var QUIZ_AXES = ['energie', 'stress', 'sommeil'];

  // Compteur dominant -> stack recommandé (page produit bundle, CTA).
  // On ne conseille JAMAIS de produit seul : toujours le stack.
  var RECO_MAP = {
    energie: { axis: 'energie', bundle: 'stack-energie' },
    stress:  { axis: 'stress',  bundle: 'stack-anti-stress' },
    sommeil: { axis: 'sommeil', bundle: 'stack-sommeil' }
  };

  // answers: { [questionId]: string | string[] }
  // questions: [{ id, options: [{ value, scores: { axis: n } }] }]
  function computeScores(answers, questions) {
    var scores = { energie: 0, stress: 0, sommeil: 0 };
    (questions || []).forEach(function (q) {
      var picked = answers ? answers[q.id] : null;
      if (picked == null) return;
      var values = Array.isArray(picked) ? picked : [picked];
      values.forEach(function (val) {
        var opt = (q.options || []).filter(function (o) { return o.value === val; })[0];
        if (!opt || !opt.scores) return;
        Object.keys(opt.scores).forEach(function (axis) {
          if (axis in scores) scores[axis] += opt.scores[axis];
        });
      });
    });
    return scores;
  }

  // Compteur max. Égalité au sommet -> énergie si elle est dans les ex-æquo,
  // sinon ordre de priorité energie > stress > sommeil (= ordre de QUIZ_AXES).
  function pickReco(scores) {
    scores = scores || {};
    var max = -Infinity;
    QUIZ_AXES.forEach(function (axis) {
      var v = scores[axis] || 0;
      if (v > max) max = v;
    });
    var best = QUIZ_AXES.filter(function (axis) { return (scores[axis] || 0) === max; })[0];
    return RECO_MAP[best] || null;
  }

  // -> /discount/CODE?redirect=/products/{bundle}?stack={axis}  (promo appliquée + atterrissage produit)
  // Sans discountCode : renvoie directement le chemin produit.
  function buildProductLink(bundleHandle, axis, discountCode) {
    if (!bundleHandle) return null;
    var path = '/products/' + bundleHandle;
    if (axis) path += '?stack=' + encodeURIComponent(axis);
    if (discountCode) {
      return '/discount/' + encodeURIComponent(discountCode) + '?redirect=' + encodeURIComponent(path);
    }
    return path;
  }

  function parseTrafficSource(search) {
    try {
      return new URLSearchParams(search || '').get('trafficSource') || null;
    } catch (e) { return null; }
  }

  function isValidEmail(email) {
    return typeof email === 'string' && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
  }

  // items: [{ variantId, qty }] -> cart permalink Shopify (+ remise auto). Fallback si bundle indispo.
  function buildCartPermalink(items, discountCode) {
    var parts = (items || [])
      .filter(function (it) { return it && it.variantId; })
      .map(function (it) { return it.variantId + ':' + (it.qty || 1); });
    var url = '/cart/' + parts.join(',');
    if (discountCode) url += '?discount=' + encodeURIComponent(discountCode);
    return url;
  }

  var api = {
    QUIZ_AXES: QUIZ_AXES,
    RECO_MAP: RECO_MAP,
    computeScores: computeScores,
    pickReco: pickReco,
    buildProductLink: buildProductLink,
    parseTrafficSource: parseTrafficSource,
    isValidEmail: isValidEmail,
    buildCartPermalink: buildCartPermalink
  };

  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  global.MaxisQuizLogic = api;
})(typeof window !== 'undefined' ? window : globalThis);
